import request from '@/plugins/axios'
import systemConfig from '@/plugins/requireConfig/systemConfig.js'

// 查询菜单分页
export function typePage(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/type/page`,
        method: 'post',
        data: data
    })
}

// 查询菜单列表
export function typeList(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/type/list`,
        method: 'post',
        data: data
    })
}

// 查询菜单详细
export function typeDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/type/detail`,
        method: 'post',
        data
    })
}

export function typeAdd(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/type/add`,
        method: 'post',
        data
    })
}

export function typeUpdate(data) {
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/type/update`,
        method: 'post',
        data
    })
}

export function typeDeleteForce(id) {
    const data = {
        id : id
    };
    return request({
        url: `/${systemConfig.sysPrefix}/sys/dict/type/deleteForce`,
        method: 'post',
        data
    })
}
